import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { getIn } from 'formik'
import PropTypes from 'prop-types'

import FileDetailsPreview from '../../../../../components/FileDetailsPreview'
import FacebookMediaUpload from '../../../FacebookMediaUpload'

import { concat } from '../../../../../helpers/common'
import { getFacebookVideoPicture } from '../../../../../features/components/FacebookPreviews/FacebookSingleMediaAdPreview/FacebookSingleMediaAdThumbnail/FacebookVideoPreview/helpers'

import { facebookImageUrlsSelector } from '../../../../../modules/selectors/mediaFiles'

import {
  CAROUSEL_ITEM_MEDIA_FILE_ERROR,
  initialFileValues,
  initialMediaValues
} from '../../../../Facebook/AdForms/fields'
import { recommendedFeedMediaSize } from '../../../../../constants/ads'

import {
  FILE_NAME,
  FILE_URL,
  IMAGE_HASH,
  MEDIA_FILE_OPTION,
  MEDIA_FILE_UPLOAD,
  MEDIA_TYPE,
  VIDEO_PICTURE
} from '../../../AdFileUpload/fields'

import useMediaStyles from '../../../FacebookMediaUpload/styles'

const ItemMediaFile = ({ formik, itemPath, isItemActive }) => {
  const classesMedia = useMediaStyles()

  const imageUrls = useSelector(facebookImageUrlsSelector)

  const { values, setFieldValue, errors, touched } = formik

  const fileUrl = getIn(values, `${itemPath}.${FILE_URL}`)
  const fileName = getIn(values, `${itemPath}.${FILE_NAME}`)
  const mediaType = getIn(values, `${itemPath}.${MEDIA_TYPE}`)
  const videoPicture = getFacebookVideoPicture(
    {
      [IMAGE_HASH]: getIn(values, `${itemPath}.${IMAGE_HASH}`),
      [VIDEO_PICTURE]: getIn(values, `${itemPath}.${VIDEO_PICTURE}`)
    },
    imageUrls
  )
  const itemMediaFileOption = getIn(values, `${itemPath}.${MEDIA_FILE_OPTION}`)
  const mediaFileError = getIn(values, `${itemPath}.${CAROUSEL_ITEM_MEDIA_FILE_ERROR}`)

  const item = getIn(values, itemPath)

  const itemErrors = getIn(errors, itemPath)
  const itemTouched = getIn(touched, itemPath)

  const mediaUrlError = itemTouched?.[FILE_URL] && itemErrors?.[FILE_URL]

  const removeExistedFile = useCallback(() => {
    const initialItemMediaValues = {
      ...item,
      ...initialFileValues,
      ...initialMediaValues,
      [MEDIA_FILE_OPTION]: itemMediaFileOption || MEDIA_FILE_UPLOAD
    }
    setFieldValue(itemPath, initialItemMediaValues)
  }, [setFieldValue, itemPath, item, itemMediaFileOption])

  return fileUrl ? (
    <div className={classesMedia.media}>
      <FileDetailsPreview
        fileName={fileName}
        filePreviewType={'image'}
        fileUrl={mediaType === 'video' ? videoPicture : fileUrl}
        isFileLoading={false}
        allowDelete={true}
        removeFile={removeExistedFile}
      />
    </div>
  ) : (
    <FacebookMediaUpload
      formik={formik}
      item={item}
      itemPath={itemPath}
      isItemActive={isItemActive}
      mediaFileErrorField={concat(itemPath, '.', CAROUSEL_ITEM_MEDIA_FILE_ERROR)}
      mediaFileError={mediaFileError}
      mediaUrlError={mediaUrlError}
      recommendedSize={recommendedFeedMediaSize}
    />
  )
}

ItemMediaFile.propTypes = {
  formik: PropTypes.object,
  itemPath: PropTypes.string,
  isItemActive: PropTypes.bool
}

export default ItemMediaFile
